import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { DomSanitizer } from '@angular/platform-browser';
import { Foodcourt } from 'src/app/model/foodcourt.model';
import { AddfoodvendorService } from 'src/app/services/addfoodvendor.service';
import { FoodcourtService } from 'src/app/services/foodcourt.service';
import { DateService } from 'src/app/services/date.service';
import { CommonService } from 'src/app/services/common.service';
import { RemovemodalvendorComponent } from 'src/app/modal/remove-modal-vendor/remove-modal-vendor.component';
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';

@Component({
  standalone: false,
  selector: 'app-list-vendor',
  templateUrl: './list-vendor.component.html',
  styleUrls: ['./list-vendor.component.scss']
})
export class ListVendorComponent implements OnInit {

  public foodcourt = new Foodcourt();
  private subscriptions = new Subscription();

  page: any;
  totalPages = 1;
  indexPage = 1;
  pageNo: number = 0;
  pageSize: number = 20;
  totalRows: number = 0;
  searchText: string = '';
  parkId: any;
  showDropdown: boolean = false;
  totalCount;
  displayCount;
  mainVendorList: any[] = [];
  newmainVendorList: any[] = [];
  vendorDeepCopy: any;
  newMainVendors: any;
  vendorTempNew: any;
  masterSelectedVendor: boolean;
  checkedVendorList: any;
  checkedOnlyVendorList: any;
  onlyVendorIds = [];
  selectedVendorName: any;
  mainVendorTypes: any[] = [];
  searchGroup: string = '';
  multiSelectGroup: any;
  searchVendorList = [];
  closedType: any;
  singleVendorDataDelete = [];
  foodCourtName: any;
  foodCourtRouterId: any;
  foodvendorRemove: any;
  foodvendorAdd: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private acroute: ActivatedRoute,
    private dateAdapter: NgbDateAdapter<string>,
    private dateSrv: DateService,
    private addfoodvendorService: AddfoodvendorService,
    private foodcourtService: FoodcourtService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private rolebasedactionService: RolebasedactionService,
  ) {
    localStorage.setItem('expandNavFoodCourt', 'true');
    const routeLink = this.sideNavService.routingChunks({
      name: 'Food Court Management',
      subNav: '1',
      subNavLink: '',
    });
    this.appStateSrv.setSideNavState(routeLink);
  }

  ngOnInit(): void {
    this.foodvendorRemove = this.rolebasedactionService.checkUserRolePermissionExits('Food Court:Remove');
    this.foodvendorAdd = this.rolebasedactionService.checkUserRolePermissionExits('Food Court:Create');
    this.route.params.subscribe((params) => {
      this.foodCourtRouterId = params['id'];
    });

    localStorage.setItem('food_court_id', this.foodCourtRouterId);

    this.foodCourtName = localStorage.getItem('food_court_name');
    localStorage.removeItem('expandNav');
    localStorage.removeItem('expandNavLand');
    localStorage.removeItem('expandNavCreateview');

    this.totalRows = 0;
    this.pageNo = 0;
    this.pageSize = 20;
    this.page = 0;
    this.indexPage = 1;

    this.getTheVendorist();
    this.getTheMainVendorGroupList();
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavFoodCourt');
    this.subscriptions.unsubscribe();
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  paginationCount(val: number) {
    return val % 10 == 0 ? Math.floor(val / 10) : Math.floor(val / 10) + 1;
  }

  searchByText(event: any) {
    if (!event || event === '') {
      // Reset to original list
      if (this.multiSelectGroup == 'All') {
        this.newmainVendorList = this.mainVendorList;
      } else {
        if (this.searchVendorList.length > 0) {
          this.newmainVendorList = this.searchVendorList;
        } else {
          this.newmainVendorList = this.mainVendorList;
        }
      }
      this.totalRows = this.newmainVendorList?.length;
      return;
    }

    // Filter based on search text
    const searchLower = event.toLowerCase();
    this.newmainVendorList = this.mainVendorList.filter((item: { foodCourtVendorName: any }) => {
      if (!item || !item.foodCourtVendorName) return false;
      return item.foodCourtVendorName.toLowerCase().includes(searchLower);
    });
    this.totalRows = this.newmainVendorList?.length;
  }

  getFilteredVendorTypes(): any[] {
    if (!this.mainVendorTypes || !Array.isArray(this.mainVendorTypes)) {
      return [];
    }
    if (!this.searchGroup || this.searchGroup === '') {
      return this.mainVendorTypes;
    }
    const searchLower = this.searchGroup.toLowerCase();
    return this.mainVendorTypes.filter((item: any) => {
      if (!item || !item.vendorTypeName) return false;
      return item.vendorTypeName.toLowerCase().includes(searchLower);
    });
  }

  handelVendorList(event: any) {
    console.log(event);
    this.page = event;
    this.indexPage = this.page;
    // this.getVegitationPlantList();
  }

  goToVendorDetails(id) {
    this.router.navigate(['/vendor-details/' + id]);
  }

  checkUncheckAll() {
    for (var i = 0; i < this.mainVendorList.length; i++) {
      this.mainVendorList[i].isSelected = this.masterSelectedVendor;
    }
    this.getCheckedItemList();
    console.log(this.masterSelectedVendor);
    if (this.masterSelectedVendor === false) {
      this.showDropdown = false;
    }
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.showDropdown = false;
    this.masterSelectedVendor = this.mainVendorList.every(function (item: any) {
      return item.isSelected === true;
    });
    console.log(this.masterSelectedVendor);
    this.getCheckedItemList();
  }

  getCheckedItemList() {

    this.checkedVendorList = [];
    this.checkedOnlyVendorList = [];
    this.onlyVendorIds = [];

    console.log(this.mainVendorList);

    for (var i = 0; i < this.mainVendorList?.length; i++) {

      if (this.mainVendorList[i].isSelected) {
        this.checkedVendorList.push(this.mainVendorList[i]);
        this.checkedOnlyVendorList.push(this.mainVendorList[i]);
        this.showDropdown = true;
      }
    }

    console.log(this.checkedOnlyVendorList);
    for (var j = 0; j < this.checkedOnlyVendorList?.length; j++) {
      this.onlyVendorIds.push(this.checkedOnlyVendorList[j].foodCourtVendorId);
    }

    console.log(this.onlyVendorIds);
    this.checkedVendorList = JSON.stringify(this.checkedVendorList);

  }

  getTheVendorist() {

    const userListPagination = {
      start: (this.page - 1) * this.pageSize, //this.page,
      offset: this.pageSize,
    };

    this.parkId = localStorage.getItem('parkId');

    this.foodcourtService.getAllVendorList().subscribe((res) => {
      if (res?.isValid === true) {
        this.mainVendorList = res?.list;
        // this.newmainSurveyList = res?.list;
        this.newmainVendorList = res?.list.filter((item: { isActive: any }) => {
          return item.isActive === true;
        });
        this.newMainVendors = res;
        this.vendorDeepCopy = JSON.parse(JSON.stringify(res));
        this.vendorTempNew = res?.list;
        this.totalRows = res?.list.length;
      } else {
        this.mainVendorList = [];
        this.newmainVendorList = [];
        this.totalRows = 0;
      }
    });

    for (var i = 0; i < this.mainVendorList?.length; i++) {
      this.mainVendorList[i].isSelected = false;
    }

    console.log(this.mainVendorList);
    this.getCheckedItemList();
  }

  getTheMainVendorGroupList() {

    this.mainVendorTypes.push(
      {
        vendorTypeId: null,
        vendorTypeName: "Opened"
      },
      {
        vendorTypeId: null,
        vendorTypeName: "Closed"
      }
    );
    const allOpt = {
      vendorTypeId: null,
      vendorTypeName: "All"
    }
    this.mainVendorTypes.unshift(allOpt);
    this.selectedVendorName = this.mainVendorTypes[0].vendorTypeName;
  }

  selectVendorType(item) {

    console.log(item);

    this.selectedVendorName = item.vendorTypeName;

    if (item.vendorTypeName !== null) {
      console.log(this.multiSelectGroup);
      if (this.multiSelectGroup == item.vendorTypeName) {
        console.log(this.multiSelectGroup);
        this.multiSelectGroup.splice(this.multiSelectGroup.indexOf(item.vendorTypeName), 1);
      } else {
        this.newMainVendors.list = this.vendorDeepCopy.list;
        this.multiSelectGroup = item.vendorTypeName;
      }
    }
    else {
      this.multiSelectGroup = 'All';
    }

    if (this.multiSelectGroup == 'Opened') {
      this.closedType = false;
    } else {
      this.closedType = true;
    }

    if (this.multiSelectGroup != '') {
      if (this.multiSelectGroup == 'All') {
        // this.newmainVendorList = this.vendorDeepCopy.list;
        this.newmainVendorList = this.mainVendorList.filter((item) => {
          return item.foodCourtVendorId != '';
        });
      } else {
        this.newmainVendorList = this.mainVendorList.filter((item) => {
          return item.isMarkClosed == this.closedType;
        });
      }
    } else {
      this.newmainVendorList = this.vendorDeepCopy.list;
    }

    this.searchVendorList = this.newmainVendorList;

    this.totalRows = this.newmainVendorList.length;
    this.totalCount = this.newmainVendorList.length;
    this.displayCount = Math.ceil(this.totalCount / this.pageSize);

    // if (this.multiSelectGroup != '') {
    //   this.selectedVendorName = this.mainVendorList.filter(group => group.isMarkClosed === this.closedType)[0].isMarkClosed;
    // } else {
    //   this.selectedVendorName = this.mainVendorList[0].isMarkClosed;
    // }
  }

  openModalRemoveVendor(foodCourtVendorId: any): void {

    this.singleVendorDataDelete = [];

    /*this.singleVendorDataDelete.push({
      "foodCourtVendorIds": foodCourtVendorId, //this.onlyVendorIds
      // "deletedBy": localStorage.getItem('claAdminId')
    });*/

    const modalOptions: NgbModalOptions = {
      size: 'md',
    };

    const modalRef = this.modalService.open(RemovemodalvendorComponent, modalOptions);
    // modalRef.componentInstance.foodCourtVendorId = this.singleVendorDataDelete[0];
    modalRef.componentInstance.foodCourtVendorId = this.onlyVendorIds;
    modalRef.componentInstance.fromDetailsPage = 'no';
  }

  addNewVendor() {
    this.router.navigate(['/create-food-vendor/']);
  }

}
